import useEmblaCarousel from 'embla-carousel-react'
import { Container, DropdownMenu, DropdownItemProps, Stack, XStack } from '@my/ui'
import { useNextRouter } from 'app/hooks/use-next-router'
import { CategoryTabsBlock } from './category-tabs.block'
import { CategoryTabsItem } from './category-tabs-item'
import { useState } from 'react'
import { SecondaryNavigation } from 'app/components'

const getCategoryHref = (category: CategoryTabsBlock['categories'][0]) => {
  if (category.slug) {
    return `/student-discount/${category.slug}`
  }

  if (category.name === 'Explore') {
    return '/student-discount'
  }

  return '/brands'
}

interface CategoryTabsProps {
  categories: CategoryTabsBlock['categories']
}

const dropdownItems = [
  {
    label: 'Discounts',
    href: '/student-discount',
  },
  {
    label: 'Chats',
    href: '/groups/feed',
  },
  {
    label: 'Life',
    href: '/life',
  },
  {
    label: 'Freshers',
    href: '/freshers',
  },
]

export const CategoryTabsComponent = ({ categories }: CategoryTabsProps) => {
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false)
  const { asPath } = useNextRouter()
  const currentPath = asPath.endsWith('/') ? asPath.slice(0, -1) : asPath

  const [emblaRef] = useEmblaCarousel({
    slidesToScroll: 1,
    containScroll: 'keepSnaps',
    skipSnaps: true,
  })

  return (
    <SecondaryNavigation>
      <Container fd="row" ai="center" size="base" gutter>
        <DropdownMenu
          open={dropdownMenuOpen}
          onOpenChange={setDropdownMenuOpen}
          initialItem={dropdownItems[0] as DropdownItemProps}
          items={dropdownItems}
          itemProps={{
            h: 40,
          }}
          contentProps={{
            top: -40,
            $gtSm: {
              display: 'none',
            },
          }}
          triggerProps={{
            h: 40,
            mr: '$2',
            $gtSm: {
              display: 'none',
            },
          }}
        />
        <Stack overflow="hidden" flex={1} ref={emblaRef as any}>
          <XStack height="auto">
            {categories.map((item) => {
              const href = getCategoryHref(item)
              const selected = currentPath === href

              return (
                <Stack
                  key={item.id}
                  minWidth={0}
                  flexGrow={0}
                  flexShrink={0}
                  pr="$2"
                  overflow="hidden"
                >
                  <CategoryTabsItem {...item} href={href} selected={selected} />
                </Stack>
              )
            })}
          </XStack>
        </Stack>
      </Container>
    </SecondaryNavigation>
  )
}
